import { useState } from 'react'
import useTranslation from '../../hooks/useTranslation'
import Item from './Item'
import Headline from '../ui/Headline'
import Text from '../ui/Text'
import FullHeightContainer from '../../UI/FullHeightContainer/FullHeightContainer'
import Container from '../../UI/Container/Container'
import SlideInView from '../../UI/SlideInView/SlideInView'

function FAQ() {
  const t = useTranslation()
  const { heading, lead, items } = t.landing.faq
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <FullHeightContainer center>
      <div>
        <Container>
          <SlideInView>
            <Headline headline={heading} size="xlarge" />
            <Text text={lead} size="xlarge" className="mt-5" />
            <div className="mt-6 border-t border-blue">
              {items.map((item, index) => (
                <Item
                  key={item.title}
                  title={item.title}
                  bullets={item.bullets}
                  open={openIndex === index}
                  onToggle={() => setOpenIndex((i) => (i === index ? null : index))}
                />
              ))}
            </div>
          </SlideInView>
        </Container>
      </div>
    </FullHeightContainer>
  )
}

export default FAQ
